import './labelSize.scss';

/**
 * Sufixo de classe para o rótulo ao lado do campo, em colunas de 12.
 * Sem labelSize (ou fora de 1..11) devolve string vazia, para que o
 * rótulo continue empilhado acima do campo como sempre foi.
 */
export function labelSizeClass(labelSize?: number): string {
    if (!labelSize || labelSize < 1 || labelSize > 11) return '';
    return ` label-inline label-size-${labelSize}`;
}
